import {
  API_CLIENT,
  API_CLIENT_POST_AXIOS
} from "../api_call/service_instances";

import {
  POST_REPORT,
  GET_REPORT_CATEGORIES,
  GET_USER_REPORTS,
  GET_RAPORTS_STATUS,
  GET_PUBLIC_REPORTS,
  GET_REPORT_LIMIT,
  GET_REPORT_IMAGES
} from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for reports part
 * --------------------------------------------------------
 */

export default {
  postReport(form_data) {
    return API_CLIENT_POST_AXIOS(POST_REPORT, form_data);
  },
  getReportCategories() {
    return API_CLIENT(GET_REPORT_CATEGORIES);
  },

  getUserReports(form_data) {
    return API_CLIENT_POST_AXIOS(GET_USER_REPORTS, form_data);
  },

  getRaportimStatuses() {
    return API_CLIENT(GET_RAPORTS_STATUS);
  },

  getPublicReports() {
    return API_CLIENT(GET_PUBLIC_REPORTS);
  },

  getReportLimit() {
    return API_CLIENT(GET_REPORT_LIMIT);
  },

  getReportImage(id) {
    return API_CLIENT(GET_REPORT_IMAGES + id);
  }
};
